import * as request from '@/utils/request'

/**
 * 自动生成 api代码【模块名：分成锁定记录】
 * 生成日期：2025/12/15 16:16:16
 * 生成路径: src/api/artist_divide_lock.js
 * 生成人：超级管理员
 */

/**
 * @description 获取列表
 * @param {*} data
 * @returns
 */
export function getArtistDivideLockList(data) {
  return request.post('/artist_divide_lock/list', data)
}
/**
 * @description 保存
 * @param {*} data
 * @returns
 */
export function saveArtistDivideLock(data) {
  return request.post('/artist_divide_lock/store', data)
}

/**
 * @description 获取详情
 * @param id
 * @returns
 */
export function getArtistDivideLockInfo(id) {
  let data = { id: id }
  return request.post('/artist_divide_lock/get_info', data)
}

/**
 * @description 获取详情
 * @param where
 * @returns
 */
export function queryArtistDivideLockInfo(where) {
  return request.post('/artist_divide_lock/query', where)
}

/**
 * @description 根据id删除单条信息
 * @param id
 * @returns
 */
export function deleteArtistDivideLock(id) {
  let data = { id: id }
  return request.post('/artist_divide_lock/delete', data)
}

/**
 * 导入
 * @param data
 * @returns {Promise}
 */
export function importArtistDivideLocks(data) {
  return request.post('/artist_divide_lock/import', data)
}

/**
 * 导出
 * @param data
 * @returns {Promise}
 */
export function exportArtistDivideLocks(data) {
  return request.postBlob('/artist_divide_lock/export', data)
}